import { Injectable } from '@angular/core';
import { createState, Store } from '@ngneat/elf';
import { withActiveId, withEntities } from '@ngneat/elf-entities';
import {
  createRequestsStatusOperator,
  withRequestsStatus,
} from '@ngneat/elf-requests';
import { TechnicalDocument } from '@prisma/client';
import { CRUDRepository } from '../../shared/crud/repository';
import { loadList } from './technical-document.actions';

type StatusPaths = 'list' | 'item';

const { state, config } = createState(
  withEntities<TechnicalDocument>(),
  withActiveId(),
  withRequestsStatus<StatusPaths>()
);

export const store = new Store({ name: 'technical-documents', config, state });
export const trackRequestsStatus = createRequestsStatusOperator(store);

@Injectable({ providedIn: 'root' })
export class TechnicalDocumentRepository extends CRUDRepository<
  TechnicalDocument,
  typeof store
> {
  constructor() {
    super(store, { loadListAction: loadList });
  }

  public override searchEntity(entity: TechnicalDocument, searchText: string) {
    searchText = searchText.toLowerCase();
    if (entity.name) {
      if (entity.name?.toLocaleLowerCase().indexOf(searchText) !== -1)
        return true;
    }
    if (entity.title) {
      if (entity.title?.toLocaleLowerCase().indexOf(searchText) !== -1)
        return true;
    }
    return false;
  }
}
